const updates = [
  {
    id: 1,
    time: '07-30 14:32',
    title: '某顶流男星深夜发文疑似回应近期黑料，评论区瞬间沦陷',
    tag: '暴走黑料',
    tagColor: 'bg-primary-500/10 text-primary-400',
  },
  {
    id: 2,
    time: '07-30 11:15',
    title: '热门综艺录制现场发生冲突，多名嘉宾情绪失控离场',
    tag: '综艺深扒',
    tagColor: 'bg-accent-500/10 text-accent-400',
  },
  {
    id: 3,
    time: '07-30 09:48',
    title: '知名网红被曝合约纠纷，涉及金额或超千万级别',
    tag: '网红观察',
    tagColor: 'bg-secondary-500/10 text-secondary-400',
  },
  {
    id: 4,
    time: '07-29 22:10',
    title: '品牌方紧急撤下争议代言人所有物料，损失预估过亿',
    tag: '暴走黑料',
    tagColor: 'bg-primary-500/10 text-primary-400',
  },
  {
    id: 5,
    time: '07-29 18:55',
    title: '某选秀冠军被扒家庭背景造假，粉丝后援会宣布解散',
    tag: '黑料社',
    tagColor: 'bg-accent-500/10 text-accent-400',
  },
  {
    id: 6,
    time: '07-29 15:20',
    title: '娱乐圈又一艺人被曝税务问题，工作室暂未回应',
    tag: '深扒专题',
    tagColor: 'bg-secondary-500/10 text-secondary-400',
  },
  {
    id: 7,
    time: '07-29 10:05',
    title: '多平台联合发布艺人数据透明度倡议，行业规范或迎来变革',
    tag: '行业动态',
    tagColor: 'bg-primary-500/10 text-primary-400',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            最新快讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            暴走黑料与黑料社即时更新，掌握第一手吃瓜资讯
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[7px] md:left-[9px] top-0 bottom-0 w-0.5 bg-background-200"></div>

            <div className="space-y-6">
              {updates.map((update, index) => (
                <div key={update.id} className="relative group cursor-pointer">
                  <div className={`absolute -left-[31px] md:-left-[33px] top-1.5 w-3.5 h-3.5 md:w-4 md:h-4 rounded-full border-2 ${
                    index === 0
                      ? 'bg-accent-500 border-accent-500'
                      : 'bg-background-50 border-background-300 group-hover:border-primary-500'
                  } transition-colors`}>
                    {index === 0 && (
                      <span className="absolute -top-5 left-1/2 -translate-x-1/2 text-[10px] text-accent-500 font-semibold whitespace-nowrap">
                        最新
                      </span>
                    )}
                  </div>
                  <div className="flex flex-col sm:flex-row sm:items-start gap-2 pb-1">
                    <span className="text-xs text-foreground-400 whitespace-nowrap font-mono">{update.time}</span>
                    <div className="flex-1 min-w-0">
                      <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium mr-2 whitespace-nowrap ${update.tagColor}`}>
                        {update.tag}
                      </span>
                      <p className="inline text-sm text-foreground-700 group-hover:text-primary-500 transition-colors leading-relaxed">
                        {update.title}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-500 cursor-pointer hover:underline whitespace-nowrap">
            加载更多快讯 <i className="ri-arrow-down-line"></i>
          </span>
        </div>
      </div>
    </section>
  );
}